var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "assist-request-content" },
    [
      _c("ChatMessage", {
        staticClass: "assist-request-content__message",
        attrs: {
          message: "何かできることはあるかにゃ？",
          "cat-icon-size": "medium",
          "use-writer-type": true,
        },
      }),
      _vm.shouldShowInfoBanner
        ? _c("div", { staticClass: "assist-request-content__info-banner" }, [
            _vm._m(0),
            _c(
              "button",
              {
                staticClass: "info-banner-close",
                attrs: { type: "button" },
                on: { click: _vm.handleInfoBannerClose },
              },
              [_c("span", { staticClass: "close-icon" }, [_vm._v("×")])]
            ),
          ])
        : _vm._e(),
      _c("ActionButtonGroup", {
        staticClass: "assist-request-content__suggestions",
        attrs: { buttons: _vm.requestButtons },
        on: {
          "button-click": _vm.handleRequestClick,
          "icon-click": _vm.handleIconClick,
        },
      }),
      _c("div", { staticClass: "assist-request-content__notice" }, [
        _vm.isThemeContext &&
        _vm.isThemeMatchingDisabled &&
        !_vm.isThemeMatchingHidden
          ? _c("p", { staticClass: "notice-text" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("themeMatching.validation.fanFictionDisabled")
                  ) +
                  " "
              ),
            ])
          : _vm._e(),
        _vm.isThemeContext
          ? _c("p", { staticClass: "notice-text" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("themeMatching.confirm.noticeNoLearning")) +
                  " "
              ),
            ])
          : _c("p", { staticClass: "notice-text" }, [
              _vm._v(
                "※ 本機能のご利用にあたり、原稿データがAIの学習に利用されることはございません。"
              ),
            ]),
      ]),
      _vm.showFeedbackManuscriptModeDialog
        ? _c("FeedbackManuscriptModeSelectionDialog", {
            attrs: { "assistant-cat-master": _vm.assistantCatMaster },
            on: { close: _vm.onCloseFeedbackManuscriptModeDialog },
          })
        : _vm._e(),
      _vm.showGenerateSummaryModeDialog
        ? _c("GenerateSummaryModeSelectionDialog", {
            attrs: { "assistant-cat-master": _vm.assistantCatMaster },
            on: { close: _vm.onCloseGenerateSummaryModeDialog },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "info-banner-content" }, [
      _c("p", { staticClass: "info-banner-text" }, [
        _vm._v(" AIを活用したアシスタント猫があなたの執筆をサポートします。"),
        _c("br"),
        _vm._v(
          " まだ見習い中のため、的を射ていないお返事や、読むのが難しい内容があるかもしれません。"
        ),
        _c("br"),
        _vm._v(" 特に、とても刺激的なシーンや少し暴力的なシーンは苦手です。"),
        _c("br"),
        _vm._v(" ご了承いただけますと幸いです。 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }